import { useAppDispatch } from '@store/hooks';
import { addModal, removeModal } from '@store/reducers/appSlice';
import classNames from 'classnames';
import { type FC, memo, useEffect } from 'react';

interface ConfirmPromptProps {
  openModal: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  processingText: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmPrompt: FC<ConfirmPromptProps> = ({
  openModal,
  title,
  message,
  confirmText,
  cancelText,
  processingText,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const dialog = document.getElementById('global_modal') as HTMLDialogElement;
    if (openModal) {
      dialog.showModal();
      dialog.addEventListener('close', onCancel);
      dispatch(addModal('global_modal'));
    } else {
      dialog.close();
      dispatch(removeModal('global_modal'));
    }

    return dialog.removeEventListener('close', onCancel);
  }, [onCancel, openModal, dispatch]);

  return (
    <dialog id="global_modal" className={classNames('modal')}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">{title}</h3>
        <p className="py-4">{message}</p>
        <div className="modal-action">
          <form method="dialog" className="flex gap-4">
            <button className="btn btn-md" onClick={onCancel} disabled={isLoading}>
              {cancelText}
            </button>
            <button className="btn btn-primary btn-md" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="loading loading-spinner" /> {processingText}
                </>
              ) : (
                confirmText
              )}
            </button>
          </form>
        </div>
      </div>
    </dialog>
  );
};
export default memo(ConfirmPrompt);
